import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';

export default class EmployeeRecordProcessWise extends Component {
    constructor(props) {
        super(props)
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            itemObject: {
                idProcess: 0,
                processList: [],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                itemCategoryName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item category name"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
        })
    };

    onRowDoubleClicked = (event) => {
        this.getMasterExpenseAccountGroupSelectbyID(event.data.idAccountGroup);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.value;
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let itemObject = this.state.itemObject;
        itemObject.processNo = "";
        itemObject.processName = "";
        itemObject.processDesc = "";
        itemObject.remarks = "";
        this.setState({
            itemObject: itemObject, validState: validState
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.getAllDropdownForStockMaster();
            });
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    getColumnWidth = (key) => {
        const colwidth = {
            "employeeName": window.innerWidth * 0.35,
            "emp_ContactNo": window.innerWidth * 0.2,
            "employeeCode": window.innerWidth * 0.08,
            "Select": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                data.processList = allData.filter(item => item.source === 'Master_Process');
                this.setState({
                    itemObject: data,
                });
            }
        });
    }

    viewRecord = (identity) => {
        let request = [this.state.idCompany, this.state.itemObject.idProcess, identity];
        this.masterEntryServices.getMasteEmployeeSelectForProcess(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;

                if (data.length > 0) {
                    data.forEach((x) => {
                        x.Select = x.processStatus === 'YES' ? true : false;
                    });
                    const columnPriority = [
                        "Select", "employeeCode", "emp_ContactNo", "employeeName",];
                    const allKeys = Object.keys(data[0]);
                    const sortedKeys = allKeys.sort((a, b) => {
                        const indexA = columnPriority.indexOf(a);
                        const indexB = columnPriority.indexOf(b);
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });

                    const dynamicColDefs = sortedKeys.map((key) => {
                        const isSelectColumn = key === "Select";

                        return {
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined
                                ? this.getColumnWidth(key)
                                : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idEmployee", "processStatus"].includes(key),
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            ...(isSelectColumn && {
                                headerCheckboxSelection: true,
                                cellRenderer: 'agCheckboxCellRenderer',
                                editable: true,
                            }),
                        };
                    });

                    this.setState({
                        rowData: data,
                        colDefs: dynamicColDefs,
                    });
                } else {
                    this.setState({
                        rowData: [],
                        colDefs: [],
                    });
                }
            }
        });
    }

    save = () => {
        let request = [];
        let data = this.state.rowData;
        data.map((x) => {
            if (x.Select === true) {
                let obj = {
                    idEmployee: x.idEmployee,
                    idProcess: this.state.itemObject.idProcess,
                    idCompany: this.state.idCompany,
                    e_Date: new Date().toISOString(),
                };
                request.push(obj);
            }
        });
        if (request.length > 0) {
            this.masterEntryServices.saveMasterEmployeeProcessWiseInsert(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    this.SwalServices.Success("Save successfully.");
                    let data = this.state.itemObject;
                    data.idProcess = 0;
                    this.setState({
                        itemObject: data,
                        rowData: [],
                        colDefs: [],
                    });
                }
            });
        }
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[125px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 237px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] pt-[0]">Employee record process wise</h1>
                                </div>
                                <div className='item-grp grid grid-cols-3 gap-2.5 my-3.5 items-end'>
                                    <div className='input-grp col-span-2'>
                                        <label>Select process</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Rate"
                                            options={this.state.itemObject.processList}
                                            value={this.state.itemObject.idProcess ? this.state.itemObject.processList.find(x => x.value === this.state.itemObject.idProcess) : 0}
                                            onChange={(event) =>
                                                this.handleChange(event, "idProcess")
                                            }
                                            className={this.state.validState?.error?.idProcess !== undefined ? "error" : ""}
                                        />
                                    </div>
                                    <div className='btn-grp flex gap-2.5'>
                                        <button className="update-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => this.viewRecord("ViewRecord")}>View records</button>
                                        {this.state.rowData.length > 0 ?
                                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => this.save()}>Save</button>
                                            :
                                            null
                                        }
                                    </div>
                                </div>

                                <AgGridReact
                                    rowData={this.state.rowData}
                                    columnDefs={this.state.colDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate={'<span>No Rows To Show</span>'}

                                    rowSelection="multiple"
                                    onRowClicked={this.onRowClicked}
                                    onCellValueChanged={this.onCellValueChanged}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
